import { FC, useCallback, useState } from "react";
import { PrimaryButton } from "../../../../../../common/components/buttons/buttons";
import { CreateAccountDialog } from "../create-account-dialog/create-account-dialog";

export const CreateAccountButton: FC = () => {

    // state
    const [dialogOpen, setDialogOpen] = useState<boolean>(false)

    // event handlers
    const handleButtonClick = useCallback(() => {
        setDialogOpen(true)
    }, [])

    const handleDialogClose = useCallback(() => {
        setDialogOpen(false)
    }, [])

    return (
        <>
            <PrimaryButton onClick={handleButtonClick}>
                Create Account
            </PrimaryButton>
            <CreateAccountDialog
                isOpen={dialogOpen}
                onClose={handleDialogClose}
            />
        </>
    )
}